import { IStyles } from '../models/app/IStyles';

export const STYLES: IStyles = {
	components: {
		app: {
			children: {
				wrapper: {

				},
			},
		},
	},
	theme: {
		base: {
			application: {
				font: {
					family: 'Arial',
				},
				background: {
					color: '#f5f6f7',
				},
				padding: {
					_value: '10px',
				},
			},
			accordionPanel: {
				children: {
					wrapper: {
						overrides: [
							{
								selector: '[data-selector="base-accordionPanel-toggle"][data-align="right"]',
								style: {
									flex: {
										grow: 'auto',
									},
								},
							},
							{
								selector: '[data-selector="base-tooltip-tooltipContentWrapper"]',
								style: {
									color: 'black',
									font: {
										size: 'smaller',
										weight: 'normal',
									},
								},
							},
						],
					},
					header: {
						display: 'flex',
						flex: {
							direction: 'row',
						},
						font: {
							size: '16px',
							weight: 'bold',
						},
						text:
						{
							transform: 'uppercase',
						},
						margin: {
							bottom: '4px',
						},
						cursor: 'pointer',
					},
					headerText: {
						flex: {
							_value: '1',
						},
					},
					content: {
						margin: {
							bottom: '10px',
						},
					},
				},
			},
			grid: {
				children: {
					wrapper: {

					},
					row: {
						display: 'flex',
						flex: {
							direction: 'row',
						},
					},
					column: {
						display: 'flex',
						flex: {
							direction: 'column',
						},
					},
					component: {

					},
				},
			},
			card: {
				children: {
					title: {
						font: {
							weight: '100',
						},
					},
					body: {
						padding: {
							_value: '5px',
						},
					},
				},
			},
			list: {
				children: {
					heading: {
						font: {
							size: '16px',
						},
						text:
						{
							transform: 'uppercase',
						},
						overrides: [
							{
								selector: '[data-selector="base-tooltip-tooltipContentWrapper"]',
								style: {
									text: {
										transform: 'initial',
									},
									font: {
										weight: 'normal',
									},
								},
							},
						],
					},
					unorderedList: {
						listStyle: {
							type: 'none',
						},
						padding: {
							_value: '0',
						},
					},
					listItem: {
						padding: {
							top: '10px',
							bottom: '10px',
						},
						display: 'flex',
						flex: {
							direction: 'row',
						},
						border: {
							bottom: {
								style: 'solid',
								width: '1px',
								color: '#cccccc',
							},
						},
					},
					content: {
						flex: {
							_value: 'auto',
						},
					},
					firstContent: {
						flex: {
							_value: 'auto',
						},
					},
					lastContent: {
						flex: {
							grow: '0',
						},
					},
				},
			},
			tooltip: {
				children: {
					wrapper: {
						display: 'inline-block',
						verticalAlign: 'text-bottom',
						overrides: [
							{
								selector: '[data-selector="base-tooltip-tooltipContentWrapper"]',
								style: {
									zIndex: '2',
								},
							},
							{
								selector: '[data-selector="base-tooltip-arrowIconWrapper"]',
								style: {
									position: 'absolute',
								},
							},
							{
								selector: 'div[data-placement="top"] [data-selector="base-tooltip-arrowIconWrapper"]',
								style: {
									bottom: '-14px',
								},
							},
							{
								selector: 'div[data-placement="bottom"] [data-selector="base-tooltip-arrowIconWrapper"]',
								style: {
									top: '-13px',
									transform: 'rotate(180deg)',
								},
							},
							{
								selector: 'div[data-placement="left"] [data-selector="base-tooltip-arrowIconWrapper"]',
								style: {
									right: '-11px',
									transform: 'rotate(-90deg)',
								},
							},
							{
								selector: 'div[data-placement="right"] [data-selector="base-tooltip-arrowIconWrapper"]',
								style: {
									left: '-11px',
									transform: 'rotate(90deg)',
								},
							},
						],
					},
					tooltipIconButton: {
						cursor: 'pointer',
						position: 'sticky',
					},
					tooltipCharacter: {
						font: {
							size: '9px',
						},
						min: {
							width: '1.5em',
						},
						margin: {
							_value: '0 0.5em',
						},
						padding: {
							top: '0.2em',
							bottom: '0.2em',
							left: '0.5em',
							right: '0.5em',
						},
						color: 'white',
						background: {
							color: '#1EA7FD',
						},
						border: {
							radius: '1.5em',
						},
						text: {
							align: 'center',
						},
					},
					tooltipIcon: {
						width: '16px',
						height: '16px',
					},
					tooltipContent: {
						max: {
							width: '250px',
						},
						background: {
							color: 'white',
						},
						border: {
							style: 'solid',
							width: '1px',
							color: '#cccccc',
							radius: '3px',
						},
						box: {
							shadow: '2px 2px 0 rgba(0,0,0,0.1)',
							sizing: 'border-box',
						},
						padding: {
							_value: '4px',
						},
						font: {
							size: 'smaller',
						},
						text: {
							align: 'center',
							transform: 'initial',
						},
						margin: {
							_value: '3px',
							bottom: '2px',
						},
					},
					clickLayer: {
						position: 'fixed',
						top: '0',
						bottom: '0',
						left: '0',
						right: '0',
						background: {
							color: 'transparent',
						},
						zIndex: '1',
					},
					arrowIcon: {
						fill: 'white',
						stroke: '#cccccc',
					},
				},
			},
		},
		fact: {
			fact: {
				children: {
					wrapper: {
						display: 'flex',
						flex: {
							direction: 'row',
						},
					},
					titleWrapper: {
						flex: {
							_value: 'auto',
						},
					},
					subtitle: {
						font: {
							size: '11px',
						},
					},
					value: {
						flex: {
							grow: '0',
						},
						text: {
							align: 'right',
						},
					},
				},
			},
			factList: {
				children: {
					wrapper: {
						overrides: [
							{
								selector: '[data-selector="base-list-listItemWrapper"][data-single-item="false"]:first-of-type',
								style: {
									border: {
										top: {
											style: 'solid',
											width: '1px',
											color: '#cccccc',
										},
									},
								},
							},
							{
								selector: '[data-selector="fact-fact-value"][data-has-title="false"]',
								style: {
									flex: {
										_value: 'auto',
									},
								},
							},
							{
								selector: '[data-selector="base-list-listItemWrapper"][data-single-item="true"] [data-selector="base-list-listItem"]',
								style: {
									border: {
										style: 'none',
									},
								},
							},
						],
					},
				},
			},
		},
		overview: {
			changeIndicator: {
				children: {
					icon: {
						verticalAlign: 'middle',
					},
					valueUp: {
						verticalAlign: 'middle',
					},
					valueDown: {
						verticalAlign: 'middle',
					},
					placeholder: {
						color: '#cccccc',
					},
				},
			},
		},
		risk: {
			riskRating: {
				children: {
					ratings: {
						border: {
							right: { _value: 'solid 1px #ADB5BD' },
							collapse: 'collapse',
						},
						display: 'flex',
						flex: {
							direction: 'row',
						},
						height: '45px',
					},
					activeRatingBox: {
						background: {
							color: '#0078C0',
						},
						color: '#FFFFFF',
						text: {
							align: 'center',
						},
						flex: {
							grow: '1',
						},
						lineHeight: '45px',
						border: {
							_value: 'solid 1px #0078C0',
							collapse: 'collapse',
						},
					},
					ratingBox: {
						border: {
							_value: 'solid 1px #ADB5BD',
							right: { _value: 'none' },
							collapse: 'collapse',
						},
						text: {
							align: 'center',
						},
						flex: {
							grow: '1',
						},
						lineHeight: '45px',
					},
					topLabels: {
						display: 'flex',
						flex: {
							direction: 'row',
						},
					},
					bottomLabels: {
						display: 'flex',
						flex: {
							direction: 'row',
						},
					},
					leftLabel: {
						flex: {
							grow: '1',
						},
						text: {
							align: 'left',
						},
					},
					rightLabel: {
						flex: {
							grow: '1',
						},
						text: {
							align: 'right',
						},
					},
				},
			},
		},
	},
};